import PropTypes from 'prop-types';
import React from 'react';
import CardTitle from '../../Elements/CardTitle/CardTitle';

import FGBLabel from '../../Elements/FGBLabel/FGBLabel';

import './HeaderSection.scss';

export default class HeaderSection extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * string of page title
         */
        title: PropTypes.string.isRequired,
        /**
         * string of subheading
         */
        subheading: PropTypes.string,
        /**
         * string of description
         */
        description: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
            .isRequired,
    };

    static defaultProps = {
        subheading: '',
    };

    render() {
        return (
            <div className="component-Resources-HeaderSection">
                <FGBLabel className="resources-label">
                    <a href="/resources">Resources</a>
                </FGBLabel>
                <CardTitle headerTag="h1" title={this.props.title} />

                <h3>{this.props.subheading}</h3>
                <p>{this.props.description}</p>
            </div>
        );
    }
}
